import React, { useState, useMemo } from "react";
import { Avatar, Modal, Popover } from "antd";
import { useAuth } from "../../authentication";
import { useHistory } from "react-router-dom";
import ChangePassword from "../Pages/ChangePassword";
import DefaultUsericon from "../../assets/Images/default-user-icon.png";

const UserProfile = () => {
  const { userSignOut, userChangePassword, authUser } = useAuth();
  const [isChangePasswordModalVisible, setChangePasswordModalVisible] =
    useState(false);
  const [resetKey, setResetKey] = useState(0); // Key for resetting the ChangePassword component
  const history = useHistory();

  const onLogoutClick = () => {
    userSignOut(() => {
      history.push("/");
    });
  };

  const onChangePassword = () => {
    showChangePasswordModal();
  };

  const showChangePasswordModal = () => {
    setChangePasswordModalVisible(true);
    // Increment the reset key to trigger a reset of the ChangePassword component
    setResetKey((prevKey) => prevKey + 1);
  };

  const hideChangePasswordModal = () => {
    setChangePasswordModalVisible(false);
  };

  const userMenuOptions = (
    <ul className="gx-user-popover">
      {/* <li>My Account</li>
      <li>Connections</li> */}
      <li onClick={onChangePassword}>Change password</li>
      <li onClick={onLogoutClick}>Logout</li>
    </ul>
  );

  const handleFormSubmit = (values) => {
    userChangePassword(values);
  };

  // Generate a unique key for the ChangePassword component
  const changePasswordKey = useMemo(() => resetKey, [resetKey]);

  return (
    <div className="gx-flex-row gx-align-items-center gx-avatar-row">
      <Popover
        placement="bottomRight"
        content={userMenuOptions}
        trigger="click"
      >
        <Avatar
          src={DefaultUsericon}
          className="gx-size-40 gx-pointer gx-mr-3"
          alt=""
        />
        <span className="gx-avatar-name">
          {authUser.clientId && authUser.role !== "corporateAdmin"
            ? authUser.clientName
              ? authUser.clientName
              : "Client Admin"
            : authUser.role === "corporateAdmin" 
              ? "Corporate Admin"
              : "Super Admin"
          }
          <i className="icon icon-chevron-down gx-fs-xxs gx-ml-2" />
        </span>
      </Popover>

      <Modal
        title={<span className="password-title">Change Password</span>}
        open={isChangePasswordModalVisible}
        onCancel={hideChangePasswordModal}
        footer={null}
      >
        <ChangePassword onFinish={handleFormSubmit} key={changePasswordKey} />
      </Modal>
    </div>
  );
};

export default UserProfile;
